const { convertArrayToCSV } = require('convert-array-to-csv');
var _ = require('underscore');
import exportExcerptHelper from './ExportExcerptHelper'
import exportProjectNameMapper from './ExportProjectNameMapper'

import {
  TRANSCRIPT,
  SNIPPET,
  URL,
  MEMOS,
  CODING_CODED_BY,
  CODING_CODED_AT,
  CODE,
  SURVEY_QUESTION,
  SURVEY_RESPONDANT_NAME
} from './ExportConstants'

const HEADER = [TRANSCRIPT, SNIPPET, URL, MEMOS, CODING_CODED_BY, CODING_CODED_AT, SURVEY_QUESTION, SURVEY_RESPONDANT_NAME]

// Long-format ("tidy") variant of the snippets export: one row per coding —
// a single code applied by a single coder — with the snippet's other columns
// duplicated on every row. Rectangular output for pivot tables and
// quantitative tools. Snippets with no codings produce no rows.
const exportCodingsCSVMapper = (projectData, excerpts, descriptors, codesData, usersData, transcripts, selectionsData) => {
  let exportRows;
  let descriptorNames = [];

  try {
    const exportObjects = exportExcerptHelper(excerpts, descriptors, codesData, usersData, transcripts, selectionsData);
    descriptorNames = exportObjects.descriptorNames;

    exportRows = exportObjects.excerpts.flatMap((excerpt) =>
      (excerpt.codings || []).map((coding) => [
        excerpt.start || 0,
        excerpt.survey_title || excerpt.transcriptName,
        excerpt.text,
        excerpt.url,
        excerpt.memos,
        coding.coderName,
        coding.codedAt,
        excerpt.survey_question_text || '',
        excerpt.survey_row_text || '',
        ...excerpt.choices,
        coding.codeName
      ])
    ).sort(function (a, b) {
      const aName = a[1].toLowerCase();
      const bName = b[1].toLowerCase();
      const localeCompare = aName.localeCompare(bName);
      if (localeCompare != 0) return localeCompare;
      // Return 0 on ties so the (spec-stable) sort preserves the helper's
      // per-snippet alphabetical code order — every multi-coded snippet
      // produces tied rows here
      if (a[0] !== b[0]) return (a[0] < b[0]) ? -1 : 1;
      return 0;
    }).map((codingArray) =>
      _.rest(codingArray)
    );
  } catch (e) {
    console.error(e);
    exportRows = [];
  }

  // UTC (ISO) date prefix via the shared name mapper, like the descriptor
  // exports — the snippets export's local-date prefix drifts from the UTC
  // calendar date in the evening/overnight hours
  const { exportFileName } = exportProjectNameMapper(projectData, 'Snippets-LongFormat');

  return {
    projectName: exportFileName,
    codingsText: convertArrayToCSV(
      exportRows,
      {
        separator: ',',
        header: [...HEADER, ...descriptorNames, CODE]
      }
    )
  }
}

export default exportCodingsCSVMapper